import {shouldUpdate} from '@pb/kit-util-should-update';

import {createRange} from './createRange';

import type {Acc, RangesListDto} from '../typedef';


type ParseData = {
    idsList: Array<string>,
    acc: Acc,
    currentRanges: RangesListDto,
};


export const parseData = (data: RangesListDto | null, localData?: RangesListDto): ParseData => {
    const acc = {} as Acc;
    const currentRanges = data || [];

    if (!localData && !shouldUpdate(data ?? {}, localData ?? {}, undefined)) {
        return {
            acc,
            idsList: [],
            currentRanges,
        };
    }

    const idsList = !data ? [] : data.map(item => {
        const {rangeId, rangeData} = createRange(item);

        acc[rangeId] = rangeData;
        return rangeId;
    });

    return {
        currentRanges,
        acc,
        idsList,
    };
};
